import { useMemo } from 'react';
import { ActivityData } from '../../../../interfaces/activity';
import {
    validateClassroomEligibility,
    EligibilityCheck,
} from '../../Common/classroomEligibilityRules';
import { useFeatureFlag } from '../../../../../common/hooks/useFeatureFlag';

/**
 * Custom hook to determine if an activity is eligible for classroom creation
 *
 * @param activity - The activity data to validate
 * @returns Eligibility status, reasons for ineligibility, and detailed checks
 */
export const useClassroomEligibility = (
    activity: ActivityData,
): EligibilityCheck => {
    const isMyClassAdcEnabled = useFeatureFlag('MYCLASS_ADC_ENABLED');

    return useMemo(() => {
        if (!activity) {
            return {
                isEligible: false,
                reasons: ['Activity data not available'],
                checks: {
                    isActive: false,
                    supportedProgram: false,
                    hasInstructors: false,
                    hasValidSize: false,
                    lmsRequirementsMet: false,
                    isSupportedCourse: false,
                },
            };
        }

        return validateClassroomEligibility(activity, {
            isMyClassAdcEnabled,
        });
    }, [
        activity?.activity_status,
        activity?.program,
        activity?.instructors,
        activity?.class_size,
        activity?.activity_modality,
        activity?.lms_type,
        activity?.v_ilt_type,
        activity?.v_ilt_id,
        activity?.v_ilt_meeting_id,
        activity?.course_name,
        isMyClassAdcEnabled,
    ]);
};
